// @ts-nocheck
import React, { useState } from "react";
import { useQuery } from "react-query";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChartColumn, faExpandAlt, faXmark } from "@fortawesome/free-solid-svg-icons";
import { faTimesCircle, faFilePdf, faCommentAlt } from "@fortawesome/free-regular-svg-icons";
import "./PostPreviewBottomBar.css";
import { t } from "i18next";
import LikePostBtn from "./components/LikePostBtn/LikePostBtn";
import SavePostBtn from "./components/SavePostBtn/SavePostBtn";
import InfosFetcher from "components/InfosFetcher/InfosFetcher";
import genRequest from "includes/request";
import Button from "components/Button/Button";
import useAccount from "classes/Accounts/hooks/useAccount";
import DocumentsButton from "./DocumentsButtonBottomBar";
import clsx from "clsx";
import PostReactionsPopper from "./components/ReactionsPopper/ReactionsPopper";

function PostPreviewBottomBar(props) {
	const { account, isAdmin } = useAccount();
	const { post, setIsCommentsExtended, toggleDocsExtend, toggleExtend, isExtended, extend, toggleStats, documents } = props;
	const [isOpen, setIsOpen] = useState(false);

	const postTypeIdCommentBtnMobileToHide = [4, 5, 14]

	return (
		<>

			<div className="post-bottom-bar d-flex w-100 justify-start flex-column">
				{/* {
					props.canComment && !props.isMobile ?
						(<Button className="btn btn-primary mb-2" onClick={() => setIsCommentsExtended(true)}>{props.commentBtnTxt ? props.commentBtnTxt : t('Posts.COMMENT_TEXT')}</Button>)
						:
						false
				} */}
				<div className="d-flex w-100 align-items-center">
					{
						props.stats !== false &&
						<div className="d-flex align-items-center icons-container">
							{
								(account.employeeId === post.employeeId || isAdmin()) && !props.isMobile &&
								<Button
									className="unstyled btn-h-bg p-1"
									title={"Statistiques de la publication"}
									onClick={toggleStats}
								>
									<span className={clsx("icons icon-data", props.isMobile ? "f-16" : "f-10")}></span>
									{/* <FontAwesomeIcon icon={faChartColumn} /> */}
								</Button>
							}
							<LikePostBtn setIsOpen={setIsOpen} postTypeId={post.postTypeId} postId={post.id} likesCount={post.likesCount} />

							{
								props.showComments && (
									(!props.isMobile || (props.isMobile && !postTypeIdCommentBtnMobileToHide.includes(post.postTypeId))) && (
										<div className="post-comments-count-cont d-flex align-items-center cursor-pointer" title={t("Posts.SHOW_COMMENTS")} onClick={() => setIsCommentsExtended(true)}>
											<span className={clsx("icons icon-bulle-edit", props.isMobile ? "f-16" : "f-10")}></span>
											<div className="post-comments-count ms-1">
												<InfosFetcher
													queryKey={["Comments", "CommentOfPost", + post.id]}
													queryFn={() => genRequest("posts/" + post.id + "/comments")}
													treat={(resp) => (resp.length === 0 && props.isMobile ? <div className="no-comment">{t('Posts.WRITE_COMMENT1')}<br /> {t('Posts.WRITE_COMMENT2')} </div> : resp.length)}
													loadText={"..."}
												/>
											</div>
										</div>)
								)
							}
							{!props.isMobile && <SavePostBtn postId={post.id} />}
						</div>
					}
					{!props.isMobile && <div className="d-flex align-items-centers">
						<DocumentsButton postId={post.id} toggleDocsExtend={toggleDocsExtend} documents={props.documents} isMobile={false} />
					</div>}

					{
						props.isMobile && <><div className="closeBtn post-preview-bottom-close-btn" onClick={props.close}><span className="icons icon-close f-30"></span></div></>
					}
					{
						extend ?
							<div className="post-extend-btn cursor-pointer ms-3" title={!isExtended ? t("Posts.EXTEND_POST") : t("Posts.REDUCE_POST")} onClick={toggleExtend}>
								{/* <FontAwesomeIcon icon={isExtended || (post && document.body.clientWidth <= 1200) ? faTimesCircle : faExpandAlt} /> */}
								<span className={clsx("icons icon-enlarge", props.isMobile ? "f-16" : "f-10")}></span>
							</div>
							:
							false
					}
				</div>
			</div>
			{
				isOpen &&
				<PostReactionsPopper
					postId={post.id}
					postTypeId={post.postTypeId}
					close={() => setIsOpen(false)}
				// referenceElement={referenceElement}
				/>
			}
		</>
	);
}

export default PostPreviewBottomBar;
